package com.downdogapp.client.controllers.menu

import com.downdogapp.client.Strings
import com.downdogapp.client.ViewController
import com.downdogapp.client.api.SetAutoRenewRequest
import com.downdogapp.client.api.Subscription
import com.downdogapp.client.singleton.AlertAction
import com.downdogapp.client.singleton.App
import com.downdogapp.client.singleton.Network
import com.downdogapp.client.views.menu.SubscriptionView

class SubscriptionViewController(val subscription: Subscription) : ViewController() {

  override val view = SubscriptionView(this)

  val autoRenewText
    get() = when {
      !subscription.canSetAutoRenew -> null
      subscription.willBeChargedAgain -> Strings.AUTO_RENEW_IS_ON
      else -> Strings.AUTO_RENEW_IS_OFF
    }

  val autoRenewSubtext
    get() = when {
      !subscription.canSetAutoRenew || subscription.endDate == null -> null
      subscription.willBeChargedAgain -> Strings.NEXT_PAYMENT_SUBTEXT(subscription.endDate)
      else -> Strings.ABBREVIATED_MEMBERSHIP_WILL_NOT_RENEW(subscription.endDate)
    }

  fun paymentMethodClicked() {
    App.openUrl(subscription.paymentMethodUrl!!)
  }

  fun autoRenewClicked(turnOn: Boolean) {
    subscription.let {
      if (turnOn) {
        App.alert(
          message = it.enableAutoRenewMessage!!,
          negativeButton = AlertAction(Strings.CANCEL),
          positiveButton = AlertAction(Strings.YES_STRING) {
            postAutoRenewRequest(
              membershipId = it.membershipId!!,
              autoRenew = turnOn
            )
          }
        )
      } else {
        App.alert(
          title = it.disableAutoRenewMessageTitle,
          message = it.disableAutoRenewMessage!!,
          negativeButton = AlertAction(Strings.CANCEL),
          positiveButton = AlertAction(Strings.YES_STRING) {
            postAutoRenewRequest(
              membershipId = it.membershipId!!,
              autoRenew = turnOn
            )
          }
        )
      }
    }
  }

  private fun postAutoRenewRequest(membershipId: String,
                                   autoRenew: Boolean) {
    view.showSpinner()
    Network.post(SetAutoRenewRequest(membershipId, autoRenew)) { json ->
      if (json == null) {
        App.alertNoInternet {
          view.hideSpinner()
        }
      } else {
        // Note: since the subscription is immutable, updating auto-renew does not change the subscription object
        // or refresh the view. But since we pop the view controller immediately after fetching the manifest
        // which triggers an update of the menu page, the state will be consistent.
        App.fetchManifest {
          view.hideSpinner()
          onBackClicked()
        }
      }
    }
  }
}
